import React from 'react';
import DataTable from '../../../Common/DataTable';

const TodoTabOwnTasks = ({
    columns,
    items,
    loading,
    totalRows,
    page,
    pageSize,
    onChangePage,
    onChangeRowsPerPage
}) => (
    <DataTable
        columns={columns}
        data={items}
        progressPending={loading}
        pagination
        paginationServer
        stickyActionPosition="right"
        selectableRows={false}
        paginationTotalRows={totalRows}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationPerPage={pageSize}
        paginationDefaultPage={page}
        progressComponent={<div className="py-4 text-center">Yükleniyor...</div>}
        noDataComponent={loading ? null : "Yeni eklenen iş bulunamadı"}
    />
);

export default TodoTabOwnTasks;
